import { createHook } from '@atomify/hooks';
import { VirtualTourPointer, VRTourPointerFilter } from '@features/virtual-tour/types';
import { elementFromPointer } from '@features/virtual-tour/utilities/interactive-image/element-from-pointer';

export interface ImagePointersHookProps {
    imageContainer: { current: HTMLElement | null };
    onPointerClick: (pointer: VirtualTourPointer) => void;
    onPointerHover: (id: string, active: boolean) => void;
}

type ImagePointer = {
    pointer: VirtualTourPointer;
    pointerHTML: Element;
};

const IS_HIGHLIGHTED_CLASS = 'is-highlighted';

export const useImagePointers = ({
    imageContainer,
    onPointerClick,
    onPointerHover,
}: ImagePointersHookProps) => {
    let imagePointers: ImagePointer[];

    return createHook({
        onDidLoad: () => ({
            setPointers: (pointers: VirtualTourPointer[]) => {
                imagePointers = pointers.map((pointer) => ({
                    pointer,
                    pointerHTML: elementFromPointer(pointer, onPointerClick, onPointerHover),
                }));
                imagePointers.forEach(({ pointerHTML }) =>
                    imageContainer.current?.append(pointerHTML),
                );
            },
            highlight: (test: VRTourPointerFilter): ImagePointer[] => {
                const highlighted = imagePointers.filter(({ pointer }) => test(pointer));
                imagePointers.forEach((pointerItem: ImagePointer) => {
                    const pointerHighlighted = highlighted.includes(pointerItem);
                    pointerItem.pointerHTML.classList[pointerHighlighted ? 'add' : 'remove'](
                        IS_HIGHLIGHTED_CLASS,
                    );
                });
                return highlighted;
            },
        }),
    });
};
